import { FC } from 'react'
import { useGetDraftReviewsQuery } from './useDraftsQuery'
import { getDateTimeString } from 'lib/helpers/dateHelper'
import { Loading } from 'components/Loading'
import styles from './ReviewsModal.module.scss'

interface ReviewsModalProps {
  draftId: number
  onClose: () => void
}

const ReviewsModal: FC<ReviewsModalProps> = ({ draftId, onClose }) => {
  const { data: draft, isLoading, isError } = useGetDraftReviewsQuery(draftId)

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>All Curation Comments</h3>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          {isLoading && (
            <div className={styles.loadingContainer}>
              <Loading />
            </div>
          )}
          {isError && (
            <div className={styles.errorMessage}>
              <p>Failed to load reviews. Please try again.</p>
            </div>
          )}
          {draft && draft.recentReviews && draft.recentReviews.length > 0 && (
            <div className={styles.reviewsList}>
              {draft.recentReviews.map((review) => (
                <div key={review.id} className={styles.reviewItem}>
                  <div className={styles.reviewHeader}>
                    <span className={styles.reviewerName}>{review.reviewedBy}</span>
                    <span className={styles.reviewDate}>{getDateTimeString(new Date(review.reviewedAt))}</span>
                  </div>
                  <p className={styles.reviewComment}>{review.comment}</p>
                  <div className={styles.reviewStatus}>
                    <span className={`${styles.statusBadge} ${styles[review.status]}`}>
                      {review.status.replace('_', ' ')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
          {draft && (!draft.recentReviews || draft.recentReviews.length === 0) && (
            <div className={styles.emptyState}>
              <p>No reviews available for this draft.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ReviewsModal
